import React, { FC, MouseEvent } from 'react';
import { IconButton } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import { Order } from 'models/order';
import { toggleLabFlagTemplate } from 'apollo/templates/order/mutation.graphql';
import { useMutation } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type LabFlagButtonProps = {
    order: Order;
    dataTest?: string;
};
const LabFlagButton: FC<LabFlagButtonProps> = ({ order, dataTest }: LabFlagButtonProps) => {
    // Read from the order, which is live (DD-3231); the toggle shows at once through an
    // optimistic cache write that Apollo rolls back if the mutation fails.
    const isFlagged = !!order.labFlag;
    const { showBoundary } = useDenthubErrorBoundary();

    const [toggleLabFlag, { loading }] = useMutation(toggleLabFlagTemplate, {
        onError(error) {
            showBoundary(error);
        },
    });

    const onFlagClick = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();
        toggleLabFlag({
            variables: { _id: order._id, flagValue: !isFlagged },
            optimisticResponse: { toggleLabFlag: { __typename: 'Order', _id: order._id, labFlag: !isFlagged } },
        });
    };

    return (
        <IconButton size="small" onClick={onFlagClick} disabled={loading} data-test={dataTest || 'lab-flag-button'}>
            {isFlagged ? <FlagIcon color="error" /> : <FlagIcon />}
        </IconButton>
    );
};

export default LabFlagButton;
